module.exports = __webpack_public_path__ + "static/media/mrcoin.17ca2112.jpg";